import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SearchFilter } from '@api/orval/apiHooks'
import type { Any } from '@api/orvalFetcher'

interface SavedFiltersState {
  [filtersArea: string]: {
    filters: SearchFilter[]
    fetched: boolean
  }
}

const initialState: SavedFiltersState = {}

const EMPTY_ARRAY: Any[] = []

const savedFiltersSlice = createSlice({
  name: 'savedFilters',
  initialState,
  reducers: {
    setSavedFilters: (state, action: PayloadAction<{ filtersArea: string; savedFilters: SearchFilter[] }>) => {
      state[action.payload.filtersArea] = {
        filters: action.payload.savedFilters,
        fetched: true,
      }
    },
  },
})

export const selectSavedFilters = (filtersArea: string) => (state: { savedFilters: SavedFiltersState }) =>
  state.savedFilters[filtersArea]?.filters || EMPTY_ARRAY
export const selectFetched = (filtersArea: string) => (state: { savedFilters: SavedFiltersState }) =>
  !!state.savedFilters[filtersArea]?.fetched

export const { setSavedFilters } = savedFiltersSlice.actions
export const savedFiltersReducer = savedFiltersSlice.reducer
